'use client'

import { cn } from '@/lib/utils'

export interface AvatarProps {
  initials: string
  color?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  src?: string
  className?: string
}

const sizes = {
  xs: { wh: 'w-5 h-5', text: 'text-[8px]' },
  sm: { wh: 'w-6 h-6', text: 'text-[9px]' },
  md: { wh: 'w-7 h-7', text: 'text-[10px]' },
  lg: { wh: 'w-9 h-9', text: 'text-[12px]' },
}

export function Avatar({ initials, color = 'var(--accent)', size = 'md', src, className }: AvatarProps) {
  const s = sizes[size]

  if (src) {
    return (
      <img
        src={src}
        alt={initials}
        className={cn('rounded-full object-cover', s.wh, className)}
      />
    )
  }

  return (
    <div
      className={cn('rounded-full flex items-center justify-center font-semibold text-white shrink-0', s.wh, s.text, className)}
      style={{ background: color }}
    >
      {initials}
    </div>
  )
}
